import { EDealRentVersion } from '../../../repositories/offer-card/entities/offer/OfferSchema';
import { IState } from '../../../store';

export function dealVersionSelector(state: IState) {
  return (state.offerData.offer.dealRentVersion as EDealRentVersion) ?? null;
}
